module.exports = __webpack_public_path__ + "img/16.7e9228fe.jpeg";